import { ActionIcon, Container, Group, Menu, Stack, Tooltip } from '@mantine/core';
import React, {useState} from 'react';
import { useParams } from 'react-router';
import {AddressBook, Menu2} from 'tabler-icons-react';
import DeleteIcon from '../../assets/DeleteIcon';
import MembersIcons from '../../assets/MembersIcons';
import PhotosIcon from '../../assets/PhotosIcon';
import PublishIcon from '../../assets/PublishIcon';
import QrCodeIcon from '../../assets/QrCodeIcon';
import ShareIcon from '../../assets/ShareIcon';
import StarIcon from '../../assets/StarIcon';
import UploadIcon from '../../assets/UploadIcon';
import useBoardHook from '../../utils/useBoardHook';
import PlannerModal from "../Planner/PlannerModal";

const BoardMenu = (props) => {
    const {
        handlerCopyShare,
        copied,
        setSelectMode,
        isDeletePhotosLoading,
        isSearchLoading,
        setOpenModalPhotos,
        setOpenAdminPanel,
        setDisableFullScreen,
        onFaceIdClick,
        showOnlyMatching,
        saveQRCode,
        setPublishModal,
        onHighlightsPhotos,
        highlightsPhotos
    } = props;

    let { subdomain } = useParams();
    const getDocumentBoard = useBoardHook(subdomain);
    const boardHasPhotos = !!getDocumentBoard?.data?.photos?.length;
    const [isPlannerOpened, setIsPlannerOpened] = useState(false);
    const published = getDocumentBoard?.data?.published;

    return (
        <>
        <Container className="hidden lg:block" px={0}>
            <Group position="center" style={{gap:'40px'}}>
                <Stack onClick={() => setOpenModalPhotos(true)} className="cursor-pointer" style={{gap:'0px'}} align="center" spacing="xs">
                    <Tooltip
                        zIndex="9999"
                        styles={{root:{"::-ms-tooltip":{zIndex:'99999'}}}}
                        label="Încarcă"
                        withArrow
                    >
                        <UploadIcon width={25} height={25} fill="#3C3C3C" />
                    </Tooltip>
                </Stack>
                {boardHasPhotos && 
                <Stack onClick={() => {setDisableFullScreen(true); setSelectMode('delete') }} className="cursor-pointer" style={{gap:'0px'}} align="center" spacing="xs">
                    <Tooltip
                        zIndex="9999"
                        label="Șterge"
                        withArrow
                    >
                        <DeleteIcon width={18} height={25} />
                    </Tooltip>
                </Stack>}
                {boardHasPhotos &&
                <Stack onClick={() => onFaceIdClick()} className="cursor-pointer" style={{gap:'0px'}} align="center" spacing="xs">
                     <Tooltip
                        zIndex="9999"
                        label="Fotografiile tale"
                        withArrow
                    >
                        <PhotosIcon active={showOnlyMatching}  />
                    </Tooltip>
                </Stack>}
                <Stack onClick={() => setOpenAdminPanel(true)} className="cursor-pointer" style={{gap:'0px'}} align="center" spacing="xs">
                    <Tooltip
                        zIndex="9999"
                        label="Gestionează moderatorii"
                        withArrow
                    >
                        <MembersIcons />
                    </Tooltip>
                </Stack>
                <Stack onClick={() => handlerCopyShare('copied-bar')} className="cursor-pointer" style={{gap:'0px'}} align="center" spacing="xs">
                    <Tooltip
                        zIndex="9999"
                        label={copied === 'copied-bar' ? "Copiat!" : "Distribuie"}
                        withArrow
                    >
                        <ShareIcon />
                    </Tooltip>
                </Stack>
                <Stack onClick={saveQRCode} className="cursor-pointer" style={{gap:'0px'}} align="center" spacing="xs">
                    <Tooltip
                        zIndex="9999"
                        label="QRCode"
                        withArrow
                    >
                        <QrCodeIcon />
                    </Tooltip>
                </Stack>
                {boardHasPhotos && <Stack onClick={onHighlightsPhotos} className="cursor-pointer" style={{gap:'0px'}} align="center" spacing="xs">
                    <Tooltip
                        zIndex="9999"
                        label="Fotografiile evidentiate"
                        withArrow
                    >
                        <StarIcon active={highlightsPhotos} />
                    </Tooltip>
                </Stack>}
                <Stack onClick={() => setIsPlannerOpened(true)} className="cursor-pointer" style={{gap:'0px'}} align="center" spacing="xs">
                    <Tooltip
                        zIndex="9999"
                        label="Confirmari invitati"
                        withArrow
                    >
                        <AddressBook width={30} height={30}/>

                    </Tooltip>
                </Stack>
            </Group>
        </Container>

        <Container px={0} mx={0} className="block lg:hidden">
            <Group position={'right'}>
                <Menu 
                    control={
                        <Tooltip opened={copied === 'copied-menu'} label="Copiat!" position="left" withArrow>
                            <ActionIcon loading={isDeletePhotosLoading || isSearchLoading}><Menu2/></ActionIcon>
                        </Tooltip>
                    }
                >
                    <Menu.Label>Galerie</Menu.Label>
                    <Menu.Item className="boardThemeLight-menu-link" onClick={() => setOpenModalPhotos(true)} icon={<UploadIcon width={20} height={21} fill="#3C3C3C" />}>Încarcă</Menu.Item>
                    {boardHasPhotos && 
                        <Menu.Item className="boardThemeLight-menu-link" onClick={() => {setDisableFullScreen(true); setSelectMode('delete') }   } icon={<DeleteIcon width={20} height={18} />}>Șterge</Menu.Item>}
                    {boardHasPhotos && 
                        <Menu.Item className="boardThemeLight-menu-link" onClick={() => onFaceIdClick()} icon={<PhotosIcon width={20} height={20} active={showOnlyMatching}  /> }>{showOnlyMatching ? 'Toate Fotografiile' : 'Fotografiile tale'}</Menu.Item>}
                    {boardHasPhotos && 
                        <Menu.Item className="boardThemeLight-menu-link" onClick={() => onHighlightsPhotos()} icon={<StarIcon width={20} height={20} active={highlightsPhotos} /> }>Fotografiile Evidentiate</Menu.Item>}
                    <Menu.Label>Planșă</Menu.Label>
                    <Menu.Item className="boardThemeLight-menu-link" onClick={() => setOpenAdminPanel(true)} icon={<MembersIcons width={20} height={20} />}>Moderatori</Menu.Item>
                    <Menu.Item className="boardThemeLight-menu-link" onClick={() => handlerCopyShare('copied-menu')} icon={<ShareIcon width={20} height={20} />}>Distribuie</Menu.Item>
                    <Menu.Item className="boardThemeLight-menu-link" onClick={saveQRCode} icon={<QrCodeIcon width={20} height={20} />}>QRCode</Menu.Item>
                    <Menu.Item className="boardThemeLight-menu-link" onClick={() => setIsPlannerOpened(true)} icon={ <AddressBook width={25} height={25}/>}>Confirmări invitati</Menu.Item>

                    {!published && 
                        <Menu.Item className="boardThemeLight-menu-link" onClick={() => setPublishModal(true)} icon={<PublishIcon width={20} height={20} fill="#3C3C3C" />}>Publică</Menu.Item>}
                </Menu>
            </Group>
        </Container>{isPlannerOpened && <PlannerModal subdomain={getDocumentBoard?.data?.subdomain} board={getDocumentBoard?.data?.id} onClose={() => setIsPlannerOpened(false)}/>}

        </>
    )
}

export default BoardMenu